module.exports = __webpack_public_path__ + "img/wheelExample.13bcce75.svg";